import { motion } from 'motion/react';
import React from 'react';

interface CompletionCheckProps {
  className?: string;
}

// Animated circle-check drawn once on mount. Shared across auth flows (passkey
// login button, 2FA code entry) so every success confirmation reads the same.
// Render it only when you want the animation to play — it draws on mount.
// non-scaling-stroke keeps the stroke a constant 1.5px at every render size.
export const CompletionCheck: React.FC<CompletionCheckProps> = ({ className }) => (
  <motion.svg className={className} width="100%" height="100%" aria-hidden="true" viewBox="0 0 16 16" fill="none">
    <motion.circle
      cx="8"
      cy="8"
      r="6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      vectorEffect="non-scaling-stroke"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
    />
    <motion.path
      d="M5.5 8.2 7 9.8 10.7 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
      initial={{ opacity: 0, pathLength: 0 }}
      animate={{ opacity: 1, pathLength: 1 }}
      transition={{ delay: 0.2, duration: 0.25, ease: 'easeOut' }}
    />
  </motion.svg>
);
